import { type LogoProps } from './types'
import { useColorScheme } from '../../theme'

/* eslint-disable @dhl/mui/no-hardcoded-colors */

/**
 * Logo
 *
 * Demos:
 * - [Logo](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/primitives-logo--docs)
 *
 */

export const DHLLogo = ({ width, height, fill }: LogoProps) => {
  const { activePaletteMode } = useColorScheme()

  // reason: still readable
  // eslint-disable-next-line no-nested-ternary
  const color = fill ? (fill === 'dark' ? '#d40511' : '#ffffff') : activePaletteMode === 'light' ? '#d40511' : '#ffffff'

  return (
    <svg viewBox="0 0 123 40" fill="none" width={width} height={height}>
      <path
        fill={color}
        d="M39.5008 17.4493C38.9614 18.18 38.073 19.4508 37.5337 20.1816C37.2481 20.5628 36.7722 21.23 38.422 21.23C40.1671 21.23 47.1471 21.23 47.1471 21.23C47.1471 21.23 48.5431 19.3238 49.717 17.7035C51.3351 15.5114 49.844 11 44.133 11C38.9931 11 21.5747 11 21.5747 11L17.6722 16.3374C17.6722 16.3374 37.9461 16.3374 38.9931 16.3374C40.0401 16.3374 40.0084 16.7504 39.5008 17.4493ZM33.0918 22.5643C31.442 22.5643 31.9496 21.8971 32.2034 21.5159C32.7428 20.7852 33.6629 19.5144 34.2023 18.8154C34.7417 18.1165 34.7416 17.7035 33.6629 17.7035C32.6159 17.7035 23.9226 17.7035 23.9226 17.7035L16.0541 28.41C16.0541 28.41 30.0777 28.41 35.2176 28.41C41.5631 28.41 45.0848 24.0893 46.1636 22.5961C46.1636 22.5643 34.8368 22.5643 33.0918 22.5643ZM45.5607 28.3465H56.7923L61.0438 22.5325H49.8122C49.8122 22.5643 45.5607 28.3465 45.5607 28.3465ZM74.5597 11L70.2448 16.8775H65.2318L69.5467 11H58.3152L50.7641 21.23H78.2718L85.7912 11H74.5597ZM61.8052 28.3465H73.0368L77.2883 22.5325H66.0567C66.0884 22.5643 61.8052 28.3465 61.8052 28.3465ZM0 24.8517V26.0908H15.6734L16.5935 24.8517H0ZM18.2433 22.5643H0V23.8033H17.355L18.2433 22.5643ZM0 28.3465H13.9918L14.8802 27.1074H0V28.3465V28.3465ZM106.002 26.059H122.5V24.82H106.89L106.002 26.059ZM104.32 28.3465H122.5V27.1074H105.208L104.32 28.3465ZM108.572 22.5643L107.683 23.8033H122.5V22.5643H108.572ZM93.85 21.23L101.369 11H89.4716L81.9522 21.23H93.85ZM80.9687 22.5643C80.9687 22.5643 80.1437 23.6763 79.763 24.2163C78.367 26.1226 79.6044 28.3465 84.2049 28.3465C89.5351 28.3465 102.258 28.3465 102.258 28.3465L106.509 22.5325L80.9687 22.5643Z"
      />
    </svg>
  )
}
